import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getRewardNode(params) {
	return client.get("member/reward/data", {
		params: params,
	});
}

function getRewardTour(params) {
	return client.get("member/reward/tour", {
		params: params,
	});
}

function getRewardFlushOut(params) {
	return client.get("member/reward/plan_a_ekonomi", {
		params: params,
	});
}

function getRewardPlanB(params) {
	return client.get("member/reward/plan_b_ekonomi", {
		params: params,
	});
}

function getHistoryRewardNode(params) {
	return client.get("member/reward/history", {
		params: params,
	});
}

function getHistoryRewardTour(params) {
	return client.get("member/reward/history_tour", {
		params: params,
	});
}

function getHistoryRewardFlushOut(params) {
	return client.get("member/reward/plan_a_ekonomi_history", {
		params: params,
	});
}

function getHistoryRewardPlanB(params) {
	return client.get("member/reward/plan_b_ekonomi_history", {
		params: params,
	});
}

function getRewardPoint(params) {
	return client.get("member/reward/point", {
		params: params,
	});
}

function claimRewardTour(params) {
	return client.post("member/reward/claim", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function claimRewardFlushOut(params) {
	return client.post("member/reward/claim_plan_a", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function claimRewardPlanB(params) {
	return client.post("member/reward/claim_plan_b", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getRewardNode,
	getRewardTour,
	getHistoryRewardNode,
	getHistoryRewardTour,
	getRewardPoint,
  claimRewardTour,

	getRewardFlushOut,
	getHistoryRewardFlushOut,
	claimRewardFlushOut,
	getRewardPlanB,
	getHistoryRewardPlanB,
	claimRewardPlanB
};